import React from "react";
import Select from "react-select";
import PropTypes from "prop-types";
import classNames from "classnames";

import Icon from "components/library/Icon";
import Sidekick from "components/library/Sidekick";

import "react-select/dist/react-select.css";
import lockViewport from "utils/lockViewport";
import dropdownStyles from "components/library/Dropdown/Dropdown.css";
import styles from "./AbstractDropdown.css";

export const AbstractDropdownChevron = () => {
  return <Icon name="chevron-down" className={styles.icon} />;
};

export default function AbstractDropdown({ className, isAsync, ...props }) {
  const inputProps = {
    autoCorrect: "off",
    spellCheck: "false",

    // Pass in the inputId prop so <label> can focus the input.
    id: props.inputId,
    "data-cy": props.dataCy || props.inputId,
  };
  const SelectType = isAsync ? Select.Async : Select;

  return (
    <div className={styles.root} onTouchStart={lockViewport}>
      <SelectType
        inputProps={inputProps}
        className={classNames(dropdownStyles.root, className, {
          [styles.error]: !!props.error,
        })}
        noResultsText={null}
        searchPromptText={null}
        loadingPlaceholder={null}
        multi={false}
        clearable={false}
        // eslint-disable-next-line no-unused-vars
        arrowRenderer={({ _, isOpen }) => (
          <Icon
            name={`chevron-${isOpen ? "up" : "down"}`}
            className={styles.arrow}
          />
        )}
        aria-invalid={!!props.error}
        {...props}
      />
      {!!props.error && (
        <Sidekick hasError title={props.error.title}>
          {props.error.message || props.error}
        </Sidekick>
      )}
    </div>
  );
}

// This component can take all the same props as react-select but these are required for render.
AbstractDropdown.propTypes = {
  className: PropTypes.string,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.instanceOf(Error),
  ]),
  inputId: PropTypes.string.isRequired,
  dataCy: PropTypes.string,
  isAsync: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  optionComponent: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};
